import moment from 'moment';
import 'moment/locale/fr';
import dict from '../dictionary';
var Url = require('url-parse');

/**
 * Linear interpolates an rgb color between startColor and endColor.
 * @param {Array} startColor [r, g, b] array, each between 0 and 255
 * @param {Array} endColor [r, g, b] array, each between 0 and 255
 * @param {number} perc Between 0 and 1
 */
export const lerp = (startColor, endColor, perc) => {
  if (perc < 0 || isNaN(perc) || perc === 'Infinity') {
    perc = 0;
  }
  const lerpResult = startColor.map((starColor, ind) => {
    return Math.round(
      (endColor[ind] - startColor[ind]) * perc + startColor[ind],
    );
  });
  return lerpResult;
};

/**
 * Turns array into an 'rgb(r, g, b)' string
 * @param {Array} color color array of [r, g, b] between 0 and 255
 */
export const colorToString = (color) => {
  return `rgb(${color.toString()})`;
};

export const dateFormater = (value, timestamp) => {
  const lang = currLang();
  return moment(value).format(lang === 'en' ? 'MMMM D' : 'MMMM D');
};

export const currLang = () => {
  const url = Url(window.location.href, true);
  if (url.query.lang === 'fr' || window.lang === 'fr') {
    moment.locale('fr');
    return 'fr';
  } else {
    moment.locale('en');
    return 'en';
  }
};
export const currPage = () => {
  const url = Url(window.location.href, true);
  const page = url.query.page || window.page;

  if (dict.pages[page]) {
    return page;
  } else {
    return dict.pages.GENPOP;
  }
};

export const percentChangeCalc = (now, previous, decimelsCount) => {
  var percent = (((now - previous) / previous) * 100)
    .toFixed(decimelsCount)
    .toLocaleString();
  if (
    isNaN(percent) ||
    percent === 'Infinity' ||
    percent === '-Infinity'
  )
    return;
  percent = percent.replace('0.00', '0');
  return percent;
};

export function getDatesRange(startDate, stopDate) {
  var dateArray = [];
  var currentDate = moment(startDate);
  var stopDateMoment = moment(stopDate);
  while (currentDate <= stopDateMoment) {
    dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
}

/**
 * Test if you need apostrophe before french word
 * @param {string} char character to test
 */
export function isVowelFr(char) {
  return 'aeiouhyAEIOUHY'.indexOf(char) !== -1;
}

const oneDay = 24 * 60 * 60 * 1000;
export const getAnomalyIndex = function (startDate, endDates) {
  let result = endDates.map(function (end) {
    let endDate = new Date(end);
    return Math.round(Math.abs((startDate - endDate) / oneDay));
  });
  return result;
};

export function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export function checkIfLessThanFive(item) {
  let result = true;
  item.map((entry) => {
    if (entry === '<50') {
      result &= true;
    } else {
      result &= false;
    }
  });
  return result;
}

export const convertTZ = (date, tzString) => {
  return new Date(
    (typeof date === 'string'
      ? new Date(date)
      : date
    ).toLocaleString('en-US', { timeZone: tzString }),
  );
};
